/** Demo usage for documents and videos storage meter. */
export const MOCK_STORAGE_USED_BYTES = 0;
